import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import config from '@/config'
import store from '@/store'
import {i18n, localeProperties} from '@/library/locale/i18n'
import mobileBridge from '@/library/mobileBridge'

import p404 from '@/components/common/errors/p404'

// layouts
import AccountLayout from '@/components/layout/AccountLayout'
import SportsLayout from '@/components/layout/SportsLayout'

// pages
import StaticContentPage from '@/components/pages/StaticContentPage'
// import AccountPage from '@/components/pages/AccountPage'
// import StaticContentPage from '@/components/pages/StaticContentPage'
import AccountPersonalDetailsComponent from '@/components/account/AccountPersonalDetailsComponent'
// import AccountTransactionHistoryComponent from '@/components/account/AccountTransactionHistoryComponent'
import AccountHistoryTransactionsComponent from '@/components/account/AccountHistoryTransactionsComponent'
import BetHistory from '@/components/account/BetHistory'
import SportsPage from '@/components/pages/SportsPage'
import LiveSportsPage from '@/components/pages/LiveSportsPage'
import EventPage from '@/components/pages/EventPage'
import IWdepositSightline from '@/components/account/IntegratedWallet/IWdepositSightline.vue'
import CashInShop from '@/components/payments/CashInShop'
import DepositAtKiosk from '@/components/account/DepositAtKiosk'
import IWwithdrawalSightline from '@/components/account/IntegratedWallet/IWwithdrawalSightline'
import IWfundingSightline from '@/components/account/IntegratedWallet/IWfundingSightline'
import ContestsStatic from '@/components/pages/ContestsStaticPage'
import AccountVouchers from '@/components/account/AccountVouchers'
import W2GTaxFormList from '@/components/account/W2GTaxFormList'
import LogoutPage from '@/components/pages/LogoutPage'
// import JoinComponent from '@/components/account/IntegratedWallet/JoinComponent'
// import JoinUsComponent from '@/components/account/IntegratedWallet/JoinUsComponent'
import ChangePassword from '@/components/account/IntegratedWallet/IWChangePassword'
import ForgottenPassword from '@/components/account/AccountForgottenPassword'
import ConfirmEmailByTempSession from '@/components/account/IntegratedWallet/ConfirmEmailByTempSession'
import AppInstaller from '@/components/common/AppInstaller'
import SetDebugLevel from '@/components/common/SetDebugLevel'
import ForceSelectionsToBetslip from '@/components/sports/bettingoffer/forceSelectionsToBetslip'
import NotificationPreferences from '@/components/account/IntegratedWallet/NotificationPreferencesV2'
import Payments from '@/components/payments/Payments'
import AccountSelfExclusionComponent from '@/components/account/AccountSelfExclusionComponent'
import AccountPlayBalanceComponent from '@/components/account/AccountPlayBalanceComponent'
import AccountPlayLimitsComponent from '@/components/account/Limits/Limits'
import AccountCloseAccountComponent from '@/components/account/AccountCloseAccountComponent'
import AccountSetPasswordByTempSession from '@/components/account/AccountSetPasswordByTempSession'
import TermsAndConditions from '@/components/termsAndConditions/termsAndConditions.vue'
import EmailAndPhoneVerification from '@/components/account/IntegratedWallet/EmailAndPhoneVerification.vue'
import Verification from '@/components/account/IntegratedWallet/Verification.vue'
import VerificationPersonalData from '@/components/account/IntegratedWallet/VerificationPersonalData'
import ResponsibleGaming from '@/components/account/IntegratedWallet/ResponsibleGaming'
import AccountSettings from '@/components/account/IntegratedWallet/AccountSettings'
// import G1 from '@/components/rgs/G1'
import NotificationsUnsubscribeComponent from '@/components/account/NotificationsUnsubscribeComponent'
import PariMutuel from '@/components/pages/PariMutuel'
import RacingPage from '@/components/pages/RacingPage'
import DepositThresholdComponent from '@/components/account/DepositThresholdComponent'
import ResponsibleGamingHistoryComponent from '@/components/account/ResponsibleGamingHistoryComponent'
import SearchPage from '@/components/pages/SearchPage'
import AccountSummary from '@/components/account/IntegratedWallet/AccountSummary'
import CareerStats from '@/components/account/CareerStats'
import SelfExclusionConfirmation from '@/components/account/Exclusions/SelfExclusionConfirmation'
import PayNearme from '@/components/payments/PayNearme'
import Sightline from '@/components/payments/Sightline'
import SightlineSuperbook from '@/components/payments/sb/SightlineSB'
import PaySafe from '@/components/payments/Paysafe'
import PNMDebit from '@/components/payments/PayNearMeGateway/PNMDebit'
import PNMCredit from '@/components/payments/PayNearMeGateway/PNMCredit'
import PNMPushDebit from '@/components/payments/PayNearMeGateway/PNMPushDebit'
import PNMCash from '@/components/payments/PayNearMeGateway/PNMCash'
import PNMAch from '@/components/payments/PayNearMeGateway/PNMAch'
import PNMAPay from '@/components/payments/PayNearMeGateway/PNMAPay'
import PNMGPay from '@/components/payments/PayNearMeGateway/PNMGPay'
import PNMPaymentCompleted from '@/components/payments/PayNearMeGateway/PNMPaymentCompleted'
import PNMPaymentNotCompleted from '@/components/payments/PayNearMeGateway/PNMPaymentNotCompleted'
import ToolboxTranslatorPage from '@/components/pages/ToolboxTranslatorPage'
import ReferAFriend from '@/components/account/ReferAFriend'
import Promotions from '@/components/account/Promotions'
import StaticPromotionPage from '@/components/pages/StaticPromotionPage.vue'
import PickAndClaim from '@/components/account/PickAndClaim'
import Registration from '@/components/account/Registration/Registration'
import VerificationMaps from '@/components/account/Verification/VerificationMaps.vue'
import SecuritySettings from '@/components/account/IntegratedWallet/SecuritySettings'
import MyEventsPage from '@/components/pages/MyEventsPage'
import MyEventsSettings from '@/components/account/MyEventsSettings'
import PNMPayPalWithdrawal from '@/components/payments/PayNearMeGateway/PNMPayPalWithdrawal'
import PNMVenmoWithdrawal from '@/components/payments/PayNearMeGateway/PNMVenmoWithdrawal'
import NuveiPaymentCompleted from '@/components/payments/Nuvei/NuveiPaymentCompleted'
import NuveiPaymentFailed from '@/components/payments/Nuvei/NuveiPaymentFailed'
import NuveiWdCard from '@/components/payments/Nuvei/NuveiWdCard'
import NuveiWdPayPal from '@/components/payments/Nuvei/NuveiWdPayPal'
import NuveiWdACH from '@/components/payments/Nuvei/NuveiWdACH'
import NuveiWdPlayPlus from '@/components/payments/Nuvei/NuveiWdPlayPlus'
import NuveiWdVipp from '@/components/payments/Nuvei/NuveiWdVipp'
import NuveiPaymentNotCompleted from '@/components/payments/Nuvei/NuveiPaymentNotCompleted'
import ParlayZone from '@/components/sports/bettingoffer/popularParlays/ParlayZone'
import BetZone from '@/components/sports/bettingoffer/BetZone.vue'
import UploadCenter from '@/components/account/UploadCenter/UploadCenter'
// Contests Routes
import ContestsPage from '@/components/pages/contests/ContestsPage'
import ContestPicksPage from '@/components/pages/contests/ContestPicksPage'
import ContestTermsAndConditionsPage from '@/components/pages/contests/ContestTermsAndConditionsPage'
import ContestAliasPage from '@/components/pages/contests/ContestAliasPage'
import ContestRegistrationSuccessfulPage from '@/components/pages/contests/ContestRegistrationSuccessfulPage'
import ContestsReportsPage from '@/components/pages/contests/ContestsReportsPage'
// wish Bet
import PlacedBetsPage from '@/components/pages/WishBet/PlacedBetsPage'
import SavedBetsPage from '@/components/pages/WishBet/SavedBetsPage'
import MyDevices from '@/components/account/IntegratedWallet/MyDevices'
import paymentsManager from '@/library/payments/paymentsManager'
import scrollToTop from '@/library/scrollToTop.js'

Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta' // the attribute name vue-meta adds to the tags it observes
})

Vue.use(Router)
const langPath = localeProperties.routerPathLang
let routes = [{
  path: '/',
  redirect: `${langPath}/sports`
}, {
  path: `/${i18n.locale}`,
  redirect: `${langPath}/sports`
}, {
  path: '/home',
  name: 'home',
  redirect: '/sports'
}, {
  path: '',
  name: 'sports-layout',
  component: SportsLayout,
  children: [
    {
      path: `/:lang/sports`,
      name: 'sports',
      component: SportsPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/navigation/:idfwbonavigation1',
      name: 'bonavigation1',
      component: SportsPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/navigation/:idfwbonavigation1/:idfwbonavigation2',
      name: 'bonavigation2',
      component: SportsPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/navigation/:idfwbonavigation1/:idfwbonavigation2/:idfwbonavigation3',
      name: 'bonavigation3',
      component: SportsPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/history/:hstate',
      name: 'history-hstate',
      component: SportsPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/event/:idfoevent',
      name: 'event',
      component: EventPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/injectselections/:idfoselectionscsv',
      name: 'event',
      component: ForceSelectionsToBetslip,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/sports/search',
      name: 'search',
      component: SearchPage,
      props: true,
      meta: { navgroupkey: 'sports' },
      children: [
        {
          path: 'sports/search/sport/:idfosport',
          name: 'searchsport',
          component: SearchPage,
          props: true,
          meta: { navgroupkey: 'sports' }
        },
        {
          path: 'sports/search/competition/:idfosport/:idfocompetition',
          name: 'searchcompetition',
          component: SearchPage,
          props: true,
          meta: { navgroupkey: 'sports' }
        }
      ]
    },
    {
      path: `/:lang/live`,
      name: 'sports-live',
      component: LiveSportsPage,
      props: true,
      meta: { navgroupkey: 'sports' }
    },
    {
      path: '/:lang/contests-static',
      name: 'contests-static',
      component: ContestsStatic,
      props: true
    },
    {
      path: '/:lang/my-events',
      component: MyEventsPage,
      name: 'my-events',
      meta: {
        authRequired: true,
        meta: { navgroupkey: 'sports' }
      }
    },
    {
      path: '/:lang/savedbets',
      name: 'savedbets',
      component: SavedBetsPage,
      props: true
    },
    {
      path: '/:lang/placedbets',
      name: 'placedbets',
      component: PlacedBetsPage,
      props: true
    },
    {
      path: '/:lang/sports/parlayzone',
      name: 'parlayzone',
      component: ParlayZone,
      props: true
    },
    {
      path: '/:lang/sports/betzone',
      name: 'betzone',
      component: BetZone,
      props: true
    }
  ]
}, {
  path: '/:lang/pm/for',
  name: 'pm-for',
  component: PariMutuel,
  props: true,
  meta: { navgroupkey: 'pm' },
  children: [
    {
      path: ':period',
      name: 'pm-for-period',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    },
    {
      path: ':period/:breed',
      name: 'pm-for-period-breed',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    },
    {
      path: ':period/:breed/:idtgmeeting',
      name: 'pm-for-period-breed-meeting',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    },
    {
      path: ':period/:breed/:idtgmeeting/:idtgrace',
      name: 'pm-for-period-breed-meeting-race',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    }
  ]
}, {
  path: '/:lang/pm',
  name: 'pmbetting',
  component: PariMutuel,
  props: true,
  meta: { navgroupkey: 'pm' },
  children: [
    {
      path: ':idtgmeeting',
      name: 'pmbetting-meeting',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    },
    {
      path: ':idtgmeeting/:idtgrace',
      name: 'pmbetting-meeting-race',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    },
    {
      path: ':idtgmeeting/:idtgrace/:pooltype',
      name: 'pmbetting-meeting-race-pool',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    },
    {
      path: ':idtgmeeting/:idtgrace/:pooltype/:bettype',
      name: 'pmbetting-meeting-race-pool-bettype',
      component: PariMutuel,
      props: true,
      meta: { navgroupkey: 'pm' }
    }
  ]
}, {
  path: '/:lang/racing',
  name: 'racing-home',
  component: RacingPage,
  props: true,
  meta: { navgroupkey: 'racing' }
}, {
  path: '/:lang/logout',
  name: 'logout',
  component: LogoutPage,
  props: true
}, {
  path: '/:lang/contests',
  name: 'contests',
  component: ContestsPage,
  meta: {
    contestsLinkDisabled: true
  },
  children: [
    {
      path: ':contestId/registration/termsandconditions',
      name: 'contests/registration/termsandconditions',
      component: ContestTermsAndConditionsPage
    },
    {
      path: ':contestId/registration/alias',
      name: 'contests/registration/alias',
      component: ContestAliasPage
    },
    {
      path: ':contestId/registration/registrationsuccessful',
      name: 'contests/registration/registrationsuccessful',
      component: ContestRegistrationSuccessfulPage
    },
    {
      path: ':contestId/:contestEntryId/mypicks',
      name: 'contests/my-picks',
      component: ContestPicksPage,
      children: [
        {
          path: 'creports/:reportName',
          name: 'contests/my-picks/creports',
          component: ContestsReportsPage
        }
      ]
    }
  ]
},
{
  path: '',
  name: 'account-layout',
  component: AccountLayout,
  children: [
    {
      path: '/:lang/account/raf',
      name: 'refer-a-friend',
      component: ReferAFriend,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/promotions',
      name: 'promotions',
      component: Promotions,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/pick-and-claim',
      name: 'pick-and-claim',
      component: PickAndClaim,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/joinUs',
      name: 'account-joinUs',
      component: Registration,
      props: true,
      meta: {
        authRequired: false,
        linkDisabled: true,
        disableJoin: true,
        registrationLinkDisabled: true
      }
    }, {
      path: '/:lang/termsAndConditions',
      name: 'termsAndConditions',
      component: TermsAndConditions,
      props: true,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/wallet-page',
      name: 'wallet-page',
      component: Payments,
      props: false,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/deposit-sightline',
      name: 'deposit-sightline',
      component: IWdepositSightline,
      props: false,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/withdrawal-sightline',
      name: 'withdrawal-sightline',
      component: IWwithdrawalSightline,
      props: false,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/funding-sightline',
      name: 'funding-sightline',
      component: IWfundingSightline,
      props: false,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/withdrawal-cashinshop',
      name: 'withdrawal-cashinshop',
      component: CashInShop,
      props: false,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/deposit-at-kiosk',
      name: 'deposit-at-kiosk',
      component: DepositAtKiosk,
      props: false,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/change-password',
      name: 'change-password',
      component: ChangePassword,
      props: false,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/reset-password',
      name: 'reset-password',
      component: ForgottenPassword,
      props: false
    }, {
      path: '/:lang/account/recovery/:value',
      name: 'set-password-by-temp-session',
      component: AccountSetPasswordByTempSession,
      props: true
    }, {
      path: '/:lang/account/confirm-email-by-temp-session',
      name: 'confirm-email-by-temp-session',
      component: ConfirmEmailByTempSession,
      props: false
    }, {
      path: '/:lang/account/verify/:verify/:pin',
      name: 'verify',
      component: EmailAndPhoneVerification,
      props: false
    }, {
      path: '/:lang/account/non-verified',
      name: 'account-non-verified',
      component: Verification,
      props: true,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/verify-personal-data',
      name: 'verify-personal-data',
      component: VerificationPersonalData,
      props: true,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/verification',
      name: 'verification',
      component: VerificationMaps,
      props: true,
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/personal-details',
      name: 'account-personal-details',
      component: AccountPersonalDetailsComponent,
      props: true,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/transactions',
      name: 'account-transactions',
      component: AccountHistoryTransactionsComponent,
      props: true,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/self-exclusion',
      name: 'account/self-exclusion',
      component: AccountSelfExclusionComponent,
      props: true,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/play-balance',
      name: 'account/play-balance',
      component: AccountPlayBalanceComponent,
      props: true,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/play-limits',
      name: 'account/play-limits',
      component: AccountPlayLimitsComponent,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/close-account',
      name: 'account/close-account',
      component: AccountCloseAccountComponent,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/:lang/account/bethistory/:state',
      name: 'history-state',
      component: BetHistory,
      props: true,
      meta: {
        authRequired: false
      }
    }, {
      path: '/:lang/account/notification-preferences',
      component: NotificationPreferences,
      name: 'notification-preferences',
      meta: {
        authRequired: false
      }
    }, {
      path: '/:lang/account/my-devices',
      component: MyDevices,
      name: 'my-devices',
      meta: {
        authRequired: false
      }
    },
    {
      path: '/:lang/account/vouchers',
      component: AccountVouchers,
      name: 'account-vouchers',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/w2gtaxforms',
      component: W2GTaxFormList,
      name: 'w2gtaxforms',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/settings',
      component: AccountSettings,
      name: 'settings',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/responsible-gaming',
      component: ResponsibleGaming,
      name: 'responsible-gaming',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/deposit-threshold',
      component: DepositThresholdComponent,
      name: 'deposit-threshold',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/responsible-gaming-history',
      component: ResponsibleGamingHistoryComponent,
      name: 'responsible-gaming-history',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/account-summary',
      component: AccountSummary,
      name: 'account-summary',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/career-stats',
      component: CareerStats,
      name: 'career-stats',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/se-confirmation',
      component: SelfExclusionConfirmation,
      name: 'se-confirmation',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/sightline',
      component: Sightline,
      name: 'sightline',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/sightline-sb',
      component: SightlineSuperbook,
      name: 'sightline-sb',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/paysafe',
      component: PaySafe,
      name: 'paysafe',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm',
      component: PayNearme,
      name: 'pnm',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-gpay',
      component: PNMGPay,
      name: 'pnm-gpay',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-apay',
      component: PNMAPay,
      name: 'pnm-apay',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-credit',
      component: PNMCredit,
      name: 'pnm-credit',
      meta: {
        authRequired: true
      }
    }, {
      path: 'account/pnm-debit',
      component: PNMDebit,
      name: 'pnm-debit',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-push',
      component: PNMPushDebit,
      name: 'pnm-push',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-ach',
      component: PNMAch,
      name: 'pnm-ach',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-cash',
      component: PNMCash,
      name: 'pnm-cash',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-payment-completed',
      component: PNMPaymentCompleted,
      name: 'pnm-payment-completed',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-payment-not-completed',
      component: PNMPaymentNotCompleted,
      name: 'pnm-payment-not-completed',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-paypal-withdrawal',
      component: PNMPayPalWithdrawal,
      name: 'pnm-paypal-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/pnm-venmo-withdrawal',
      component: PNMVenmoWithdrawal,
      name: 'pnm-venmo-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-payment-completed',
      component: NuveiPaymentCompleted,
      name: 'nuvei-payment-completed',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-payment-failed',
      component: NuveiPaymentFailed,
      name: 'nuvei-payment-failed',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-payment-not-completed',
      component: NuveiPaymentNotCompleted,
      name: 'nuvei-payment-not-completed',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-card-withdrawal',
      component: NuveiWdCard,
      name: 'nuvei-card-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-paypal-withdrawal',
      component: NuveiWdPayPal,
      name: 'nuvei-paypal-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-ach-withdrawal',
      component: NuveiWdACH,
      name: 'nuvei-ach-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-playplus-withdrawal',
      component: NuveiWdPlayPlus,
      name: 'nuvei-playplus-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/nuvei-vipp-withdrawal',
      component: NuveiWdVipp,
      name: 'nuvei-vipp-withdrawal',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/security-settings',
      component: SecuritySettings,
      name: 'security-settings',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/my-events-settings',
      component: MyEventsSettings,
      name: 'my-events-settings',
      meta: {
        authRequired: true
      }
    }, {
      path: '/:lang/account/uploadcenter',
      component: UploadCenter,
      name: 'uploadcenter',
      meta: {
        authRequired: true,
        uploadCenter: true
      }
    }
  ]
}, {
  path: '/:lang/setdebug/:level',
  name: 'setDebug',
  component: SetDebugLevel,
  props: true
}, {
  path: '/:lang/404',
  name: 'page-not-found',
  component: p404
}, {
  path: '*',
  redirect: `${langPath}/404`
}, {
  path: '/:lang/app',
  name: 'app',
  component: AppInstaller,
  props: true
}, {
  path: '/:lang/android',
  name: 'android',
  component: AppInstaller,
  props: true
}, {
  path: '/:lang/loginWithAuthWebToken/:token',
  name: 'loginWithAuthWebToken'
}, {
  path: '/:lang/info/:infopagename',
  name: 'info',
  component: StaticContentPage,
  props: true
}, {
  path: '/:lang/toolbox/translator',
  name: 'toolbox-translator-page',
  component: ToolboxTranslatorPage,
  props: true
}, {
  path: '/:lang/unsubscribe-from-notifications',
  name: 'unsubscribe-from-notifications',
  component: NotificationsUnsubscribeComponent,
  props: true
}, {
  path: '/:lang/promotions',
  name: 'pspromotions',
  component: StaticPromotionPage,
  props: true
}]

const router = new Router({
  // uncomment to turn on routes with no hash
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (localeProperties.isMultiLangEnabled) {
    let language = to.params.lang
    if (!localeProperties.isLocaleSupported(language)) {
      i18n.locale = localStorage.userLocale || localeProperties.getDefaultLocale
      localStorage.userLocale = localStorage.userLocale || localeProperties.getDefaultLocale
      next(i18n.locale)
    } else {
      if (to.name === 'page-not-found' && !to.redirectedFrom.includes('/' + language + '/')) { // support old regular routes without language parameter
        next({path: '/' + language + to.redirectedFrom})
      }
      localStorage.userLocale = language
    }
  }
  try {
    if (to && to.query && (to.query.internalProxy || to.query.internalLink)) {
      // info: use /?internalProxy=/{routepath} querystring on root navigation to proxy browser location (from external source) to specified path using router push instead of location change
      if ((to.query.internalProxy && to.query.appWebView) && window.ctsautoconf.MOBILE_LS) {
        let openLink = config.app.autoconf.CONTENT_SERVER_HOSTNAME + to.query.internalProxy
        mobileBridge.bridgeSendRequest('openLink', openLink)
        return false
      }
      console.log('to.query', to.query)
      if (to.query && to.query.component) {
        console.log('to.query.component', to.query.component)
        if (to.query.component === 'welcome') store.commit('overlayState/setWelcomeDialogGenericState', false)
        if (to.query.component === 'whatsnew') store.commit('overlayState/setWhatsNewDialogState', false)
      }
      if (window.ctsautoconf.ACCOUNT_SUMMARY_FLOW && to.query.internalLink) {
        console.log('internalLink redirects to: ' + to.query.internalLink)
        let link = to.query.internalLink.indexOf('/') !== 0 ? '/' + to.query.internalLink : to.query.internalLink
        const isInfoPage = link.includes('/info/')
        const customPath = isInfoPage && to.hash ? link + to.hash : link
        console.log('locale customPath', customPath)
        return next({path: customPath})
        // return next({path: to.query.internalLink})
      }
      console.log('internalProxy redirects to: ' + to.query.internalProxy)
      let proxy = to.query.internalProxy.indexOf('/') !== 0 ? '/' + to.query.internalProxy : to.query.internalProxy
      const isInfoPage = proxy.includes('/info/')
      const customPath = isInfoPage && to.hash ? proxy + to.hash : proxy
      return next({path: customPath})
      // return next({path: to.query.internalProxy})
    }
  } catch (err) {
    console.log('internalProxy failed to redirect')
    return next({ path: '/' })
  }
  const isLoggedIn = localStorage.loggedIn
  const isProtected = to.matched.some(record => record.meta.authRequired)
  const linkDisabled = to.matched.some(record => record.meta.linkDisabled)
  const registrationLinkDisabled = to.matched.some(record => record.meta.registrationLinkDisabled)
  const disableJoin = (config.app.DISABLE_JOIN_BUTTON && config.app.TEMPLATE !== 'generic_2') || config.app.autoconf.ROBO === true
  paymentsManager.checkIsRedirectedFromInAppBrowserAndIntercept()

  /* disable upload center */
  const isDocumentsUploadRequired = store.getters['getRequiresDocumentsUpload']
  const isUploadCenter = to.matched.some(record => record.meta.uploadCenter)
  if (!isDocumentsUploadRequired && isUploadCenter) {
    return next({ path: '/' })
  }

  if (isProtected) {
    if (isLoggedIn) {
      return next()
    } else {
      return next({ path: '/' })
    }
  }
  /* Boyd - Disable promotions,registration... */
  if (linkDisabled && config.app.BRAND === 'rw') {
    return next({ path: '/' })
  }

  /* Disable registration */
  if (disableJoin && registrationLinkDisabled) {
    return next({ path: '/' })
  }

  /* disable contests */
  const contestsEnabled = config.app.autoconf.CONTESTS
  const contestsLinkDisabled = to.matched.some(record => record.meta.contestsLinkDisabled)

  if (!contestsEnabled && contestsLinkDisabled) {
    return next({ path: '/' })
  }

  if (config.app.autoconf.ROUTERNAVGROUPS && config.app.autoconf.ROUTERNAVGROUPS && config.app.autoconf.ROUTERNAVGROUPS.groups && to.meta.navgroupkey) {
    let groups = config.app.autoconf.ROUTERNAVGROUPS.groups.filter(grp => grp.key === to.meta.navgroupkey)
    if (groups.length > 0 && groups[0].isactive === false) {
      return next({ path: groups[0].exitpath })
    }
  }

  next()
})

router.afterEach((to, from) => {
  // setTimeout to prevent overlapping the betting offer on iOS apps
  // checking hashes - prevent account pages bouncing on mobile devices
  if (((to && !to.hash) && (from && !from.hash)) || ((from && from.hash) && (to && !to.hash))) {
    setTimeout(() => { scrollToTop() }, 300)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js